import "@sphtech/dmg-design-system/dist/theme-icon.css";
import "@sphtech/dmg-design-system/assets/icon/fonts.css";

import Newsticker from "@components/Modules/Newsticker/Newsticker";
import { configSite } from "@pub/config";
import { BaseLayout, CustomClassContext } from "@sphtech/dmg-design-system";
import { useLocation } from "react-router";

import { configHeader, hamburgermenuSvgSource } from "./config/configHeader";
import customStyle from "./custom.module.css";
import logoSvgSource from "./logo.svg?raw";
import NavbarICON from "./NavbarICON";
import { RoutePaths } from "./routePaths";

type BaseLayoutProps = {
  ArticleTitle?: string;
  children: React.ReactNode;
  ads?: boolean;
  leaderboard?: boolean;
  skipMobileBanner?: boolean;
};

/**
 * Reusable Base layout specific to ICON.
 */
const IconBaseLayout = ({
  ArticleTitle,
  children,
  ads = true,
  leaderboard = true,
  skipMobileBanner,
}: BaseLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  return (
    <CustomClassContext.Provider
      value={{
        button: {
          primary: customStyle["icon-button-primary"],
          secondary: customStyle["icon-button-secondary"],
        },
        figureCaptions: {
          imageCaption: customStyle["icon-image-caption"],
        },
        heading: {
          headingBase: customStyle["icon-heading-base"],
          headingSplit: customStyle["icon-heading-split"],
        },
        navLinks: {
          verticalLineFooter: customStyle["icon-nav-links-footer"],
        },
        textLink: customStyle["icon-text-link"],
        navbar: {
          dropDown: customStyle["navbarDropdown"],
        },
      }}
    >
      <BaseLayout
        siteName={configSite.name}
        ArticleTitle={ArticleTitle}
        ads={ads}
        leaderboard={leaderboard}
        NewsTicker={<Newsticker />}
        RoutePaths={RoutePaths}
        svgSource={logoSvgSource}
        svgHamburgerMenu={hamburgermenuSvgSource}
        mciText={
          <span suppressHydrationWarning>
            MDDI (P) 004/11/2025. Published by SPH Media Limited, Co. Regn. No.
            202120748H. Copyright © {currentYear} SPH Media Limited. All rights
            reserved.
          </span>
        }
        socialIconProps={configHeader.socialMedia}
        megaMenuProps={{
          NewsLetterProps: configHeader.megaMenu.newsletter,
          CloseButtonProps: configHeader.megaMenu.closeButton,
          divider: configHeader.megaMenu.divider?.footer,
        }}
        skipMobileBanner={skipMobileBanner}
        currentLocation={location}
        NavbarComponent={NavbarICON}
      >
        {children}
      </BaseLayout>
    </CustomClassContext.Provider>
  );
};

export default IconBaseLayout;
